import { apiClient, type ApiResponse } from './client';

export interface BatchStockRecord {
  id: string;
  batchNumber: string;
  supplierBatchNo?: string | null;
  batchType?: string;
  currentQty: number;
  initialQty: number;
  mfgDate: string | null;
  expiryDate: string | null;
  status: 'ACTIVE' | 'PARTIAL' | 'EXHAUSTED' | string;
  warehouseId: string;
  warehouseName?: string;
  receivedDate?: string | null;
}

export interface FIFOAllocation {
  batchId: string;
  batchNumber: string;
  allocatedQty: number;
  mfgDate: string | null;
  expiryDate: string | null;
  warehouseId: string;
}

export interface FIFOAllocationResult {
  allocations: FIFOAllocation[];
  totalAllocated: number;
  unallocatedQty: number;
  isFullyAllocated: boolean;
}

export async function fetchBatchesForItem(
  itemId: string,
  warehouseId?: string,
): Promise<BatchStockRecord[]> {
  try {
    const params: Record<string, string> = { itemId };
    if (warehouseId && warehouseId !== 'ALL') {
      params.warehouseId = warehouseId;
    }
    const { data } = await apiClient.get<ApiResponse<BatchStockRecord[]>>(
      '/api/v1/inventory/batches',
      { params },
    );
    return data.data || [];
  } catch (error) {
    console.error('Failed to fetch batches for item:', error);
    return [];
  }
}

export async function fetchFIFOAllocation(
  itemId: string,
  warehouseId: string,
  qty: number,
): Promise<FIFOAllocationResult> {
  const { data } = await apiClient.get<ApiResponse<FIFOAllocationResult>>(
    '/api/v1/inventory/batches/suggest-fifo',
    {
      params: { itemId, warehouseId, qty },
    },
  );
  return data.data;
}

export async function apiGenerateBatchNumber(
  type: 'GRN' | 'PROD' = 'GRN',
): Promise<string> {
  const { data } = await apiClient.get<ApiResponse<{ batchNumber: string }>>(
    '/api/v1/inventory/batches/generate-number',
    { params: { type } },
  );
  return data.data.batchNumber;
}
